import { MetaExpression } from './meta-expression';
export class Meta {
}
Meta.id = new MetaExpression('_id', 'id', null);
Meta.sequence = new MetaExpression('_sequence', 'sequence', null);
Meta.deleted = new MetaExpression('_deleted', 'deleted', null);
Meta.expiration = new MetaExpression('_expiration', 'expiration', null);
//# sourceMappingURL=meta.js.map